import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Pricebreakdown from '../../planner/itinerary/components/price-breakdown';
import ButtonSpinner from '../../shared/UI/button-spinner';
import dayjs from 'dayjs';
import AdvancedFormat from 'dayjs/plugin/advancedFormat';
import { bindActionCreators } from 'redux';
import { ToggleLockInModal } from '../../../actions/utils';
import { withApollo } from 'react-apollo';
import _sumBy from 'lodash/sumBy';
import ShareButton from '../share-button';
import { ISOCurrencyCovert } from '../../../helpers/locationHelper';

dayjs.extend(AdvancedFormat);


const ItineraryWidget = (props) => {
   
    const [priceBreakdownVisible, onPriceBreakDown] = useState(false);
    const [isSubmitting] = useState(false);

    useEffect(() => {
        if(priceBreakdownVisible) document.body.addEventListener('click', documentClickHandler);
        return () => {
            document.body.removeEventListener('click', documentClickHandler);  
        }
    })

    const documentClickHandler = (e) => {
        try{
            if(e.target.offsetParent.className !== "itinerary-pricebreakdown round-corners" 
            && e.target.offsetParent.className !== "max-width-5 mx-auto relative" 
            && priceBreakdownVisible){
                onPriceBreakDown(false)
            }
        }catch(e){}
    }

    const bookTrip = () => {
        if(!props.isShare) props.ToggleLockInModal(true);        
    }

    const bookNowButton = () => {

        const { isShare, currentBooking:{status, meta:{days}, passengers, prices, iso_currency} } = props;
        const grandTotal = prices.trips + prices.accommodation;

        let pricePerDay = days > 1 ? (grandTotal / days) : prices.total;
        pricePerDay = pricePerDay / passengers.length;

        return (
            <>
                { (!isShare && status !== "confirmed") && ('Book now') }
                { (!isShare && status === "confirmed") && ('Confirmed') }
                { (isShare && status !== "confirmed") && ('Your Quote') }
                { (isShare && status === "confirmed") && ('Confirmed') }
                <br />
                <span className="regular lowercase f-size-12 font-proxima-nova">from {ISOCurrencyCovert(iso_currency).props.children}{parseFloat(pricePerDay).toFixed(2)} per person per day</span>
            </>
        )
    }

    const { currentBooking:{iso_currency, uuid, tmsBookingId, items, itinerary, prices, status}, isShare } = props;
    const _uuid = uuid !== undefined ? uuid : "";
    const _items = items !== undefined ? items : []; 
    const _prices = prices !== undefined ? prices : "";
    const _itinerary = itinerary !== undefined ? itinerary : [];
    const _startDate = (_itinerary.length > 0) ? dayjs(_itinerary[0].date).format("D MMMM") : "";
    const _endDate = (_itinerary.length > 0) ? dayjs(_itinerary[_itinerary.length -1].date).add(_itinerary[_itinerary.length -1].nights,'days').format("D MMMM") : "";
    const _year = (_itinerary.length > 0) ? dayjs(_itinerary[0].date).format("YYYY") : "";

    if(_itinerary.length === 0){
        return null;
    }else{

        return (
            <>
            <div className="itinerary-wrapper">
                <div className="max-width-5 mx-auto relative">
                    <div className="clearfix">
                        <div className="col col-12 md-col-6 px2 mb2">
                            <h2 className="margin-b-10">{ (_items.length > 0) ? _items[0].name  : "" }</h2>

            
                            <div className="sm-flex">
                                <div className="sm-flex items-center mr3">
                                    <p className="bold">{_startDate} - {_endDate}, {_year}</p>
                                </div>

                                { (!isShare && status !== "confirmed") && <div className="sm-flex"><ShareButton link={`${process.env.REACT_APP_PLANNER_URL}${process.env.REACT_APP_ITINERARY_PAGE}?id=${uuid}`}/></div> }
                                
                            </div>


                        </div>
            
                        <div className="col col-12 md-col-6 px2 left-right">
                            <div className="clearfix">
                                <div className="col col-12 text-left">

                    
                                    <div className="inline-block mr3">
                                        <p className="uppercase f-size-12 mb1 left-align">
                                            { (status !== "confirmed") && ('Total price') }
                                            { (status === 'confirmed') && ('Total due')  }
                                        </p>
                                        <p className="bold f-size-26">
                                            { (status !== "confirmed") && (`${ISOCurrencyCovert(iso_currency).props.children}${parseFloat(_prices.total).toFixed(2)}`) }
                                            { (status === "confirmed") && (`${ISOCurrencyCovert(iso_currency).props.children}${parseFloat(_prices.due).toFixed(2)}`) }
                                            <span className="f-size-14"> {iso_currency}</span>
                                        </p>
                                    </div>

                                    <button className={`busabout--cta rounded-corner inline-block align-bottom ${(status === "confirmed") ? 'green-background' : 'orange'} ${(status === "confirmed") ? 'no-pointer-event': ''}`} onClick={bookTrip} disabled={props.itinerary !== undefined && props.itinerary.length > 1 ? false : true}>
                                        { !isSubmitting && bookNowButton() }
                                        { isSubmitting && <ButtonSpinner clazz={"white"} /> } 
                                    </button>
                            
                                    
                                    <p className="f-size-12 mt2">
                                        Booking {status === "confirmed" ? "Ref" : "Quote"} <span className="bold">{ status === "confirmed" ? tmsBookingId : _uuid}</span>. See the&nbsp;
                                        <button className="bold orange-text" onClick={() => onPriceBreakDown(!priceBreakdownVisible)}>
                                            price breakdown&nbsp;
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="12" height="12" className={`price-break-down-arrow ${priceBreakdownVisible ? 'active' : ''}`}>
                                        <path fill="currentColor" d="M441.9 167.3l-19.8-19.8c-4.7-4.7-12.3-4.7-17 0L224 328.2 42.9 147.5c-4.7-4.7-12.3-4.7-17 0L6.1 167.3c-4.7 4.7-4.7 12.3 0 17l209.4 209.4c4.7 4.7 12.3 4.7 17 0l209.4-209.4c4.7-4.7 4.7-12.3 0-17z"></path>
                                        </svg>
                                        </button>
                                    </p>
                                </div>
                            </div>
                        </div>
                        
                    </div>
            
                    <Pricebreakdown visible={priceBreakdownVisible} />
                </div>
            </div>
            </>
        )
    
    }
}


const mapStateToProps = state => {
    return{
        currentBooking:state.currentBooking,
        itinerary:state.currentBooking.itinerary
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
        ToggleLockInModal
    }, dispatch);
}

export default withApollo(connect(mapStateToProps, mapDispatchToProps)(ItineraryWidget));